import {
  Flex,
  Table,
  AbsoluteCenter,
  Spinner,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Input,
  useColorModeValue,
  Button,
  useToast,
  Box,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { ViewIcon } from '@chakra-ui/icons';
// Custom components
import LockersApi from 'api/lockers';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import PageError from 'components/nopermission/PageError';
import { isValidUUID } from 'utils/fetchUtils';

//Remove when API sends Data
export default function CheckTable(props) {
  const withId = props.withId;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  //Data Fetching
  // const [data, setData] = useState([]);
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState();
  const [filterEndDate, setFilterEndDate] = useState();
  const { getPermissionsForModule } = usePermissions();
  const [lockersPermissions, setLockersPermissions] = useState(null);
  const [fetchLockerError, setFetchLockerError] = useState(false);

  const customerId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }
  // const [customerId, setCustomerId] = useState(
  //   'b600a88b-3b8a-46d1-85b5-34fa20520aa4'
  // );

  const selectedStatusTypeValue = Array.isArray(selectedStatusType)
    ? selectedStatusType?.map((option) => option.value).join(',')
    : selectedStatusType.value;

  // console.log(
  //   'from order to check multiselect',
  //   selectedOrderTypeValue,
  //   selectedStatusTypeValue
  // );

  const FetchLockerList = async () => {
    if (customerId && !isValidUUID(customerId)) {
      setFetchLockerError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await LockersApi.List({
        currentPage,
        itemsPerPage,
        // sort: 'name:asc',
        searchTerm,
        selectedStatusTypeValue,
        filterStartDate,
        filterEndDate,
        customerId,
      });
      response = response.data;
      console.log('Response from LockersApi', response);
      setLoading(false);
      if (response.status_code === 200) {
        setFetchLockerError(false);
        setList(response?.data);
        setListTotal(response?.data.length);
      } else {
        setFetchLockerError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchLockerError(true);
      console.log(err);
      setList([]);
    }
  };

  useEffect(() => {
    const lockersPermissions = getPermissionsForModule([Modules.Lockers]);
    setLockersPermissions(lockersPermissions);
    FetchLockerList();
  }, [
    searchTerm,
    currentPage,
    selectedStatusTypeValue,
    filterStartDate,
    filterEndDate,
    getPermissionsForModule,
    customerId,
  ]);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = async (search) => {
    setSearchTerm(search);
    setCurrentPage(1); // Reset currentPage to 1 on each search
  };

  // console.log('List conatis', list);

  if (!lockersPermissions?.read) {
    return <NoPermissionsMessage module={Modules.Lockers} />;
  }

  return fetchLockerError ? (
    <PageError />
  ) : (
    <>
      <Flex
        mt={withId ? '0px' : '8rem'}
        px={withId ? '0px' : '25px'}
        justify='left'
        mb='20px'
        align='center'>
        <Flex
          direction='column'
          gap={4}
          pt={withId ? 0 : 5}>
          <Flex
            direction={{ base: 'column', '2xl': 'row' }}
            gap={4}>
            <Flex
              direction={{ base: 'column', md: 'row' }}
              gap={4}>
              <Flex>
                <Input
                  variant='auth'
                  type='text'
                  minWidth='150px'
                  placeholder='Search ...'
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </Flex>
            </Flex>
          </Flex>
          {/* <AddModal
            Icon={<AddIcon />}
            head={'Add Customer Admin User'}
            func={FetchOrderList}
          /> */}
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr /* bgColor='yellow' */>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  From
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Weight ( gm )
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Current Amount ( Rs )
                </Flex>
              </Th>

              <Th
                pe='25px'
                borderColor={borderColor}>
                <Flex
                  justifyContent='center'
                  // backgroundColor='red'
                  width='100%'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.operation?.name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {isNaN(parseFloat(obj.total_weight)) ? 'N/A' : parseFloat(obj.total_weight).toFixed(3)}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.current_amount}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex
                      // bgColor='red'
                      justifyContent='center'>
                      {/* <EditModal
                          Icon={<EditIcon />}
                          head={'Update Customer Admin User'}
                          func={FetchOrderList}
                          currentUser={obj}
                        /> */}
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/lockerdetails/${customerId}`,
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                      {/* {obj.is_active === true ? (
                        <PopDelete
                          Icon={<DeleteIcon />}
                          button={
                            <Button
                              colorScheme='red'
                              onClick={handleDelete}
                              value={obj.id}>
                              Delete
                            </Button>
                          }
                        />
                      ) : (
                        'Disabled'
                      )} */}
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </>
  );
}
